module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-5-large-e6d4f03625fc4c5a66806e46a4d13d5e.jpg";